import { Tier3RowActions } from '@openx/constants/rowActions';
import type { RowActionProps } from '@openx/types/tableHelpers';
import { sortMenuButtonItems } from '@openx/utils/lib/tableHelpers';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useAuth } from '../../../../components/AuthContext/context';
import { isMasterOrganisation } from '../../../../permissions/validators';
import type { CuratedDealBuyerDiscountApi } from '../../../../types/curatedDealBuyerDiscount';
import { useCuratedDealBuyerDiscountDelete } from '../../hooks/useCuratedDealBuyerDiscountDelete';

export const useCuratedDealBuyerDiscountRowActions = () => {
  const { session } = useAuth();
  const { deleteCuratedDealBuyerDiscount } = useCuratedDealBuyerDiscountDelete();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const isMasterOrg = isMasterOrganisation(session);

  return useMemo<RowActionProps<CuratedDealBuyerDiscountApi>[] | undefined>(() => {
    if (isMasterOrg) {
      return undefined;
    }

    return sortMenuButtonItems<CuratedDealBuyerDiscountApi>({
      [Tier3RowActions.Delete]: {
        danger: true,
        'data-test': 'delete',
        label: t('Delete'),
        onClick: curatedDealBuyerDiscount => deleteCuratedDealBuyerDiscount(curatedDealBuyerDiscount),
      },
      [Tier3RowActions.Edit]: {
        'data-test': 'edit',
        label: t('Edit'),
        onClick: ({ uid }) => navigate(`/discounts/${uid}/edit`),
      },
    });
  }, [deleteCuratedDealBuyerDiscount, isMasterOrg, navigate, t]);
};
